export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ARCHIVED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archived"])},
        "CURRENT_BRIEF": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Current ", _interpolate(_named("brief"))])},
        "DEFAULT_BRIEF": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Default ", _interpolate(_named("brief"))])},
        "MY_BRIEFS": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["My ", _interpolate(_named("briefs"))])},
        "MATCHED_BRIEFS": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Matched ", _interpolate(_named("briefs"))])},
        "NOT_FOUND": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No results found."])},
        "NOT_DEFAULT_BRIEF_FOUND": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["No default ", _linked("BRIEF.LOW.SING", undefined, _type), " found."])},
        "SEARCH_BRIEF_PLACEHOLDER": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Search for ", _interpolate(_named("brief"))])},
        "ASSET_TYPES": {
          "BIO": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pharma assets"])},
          "TEC": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technologies"])},
          "COM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organizations"])},
          "COH": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consumer health assets"])}
        }
      }
    }
  })
}
